<script setup>
import Header from '@/components/common/header/Header'
import Footer from '@/components/common/footer/Footer'
import xAppGuide from '~/components/common/xAppGuide.vue'

const scroll = ref(null)

const route = useRoute()
const isAppByRoute = computed(() => route.query.inApp)
watch(() => route.path, () => {
  scroll.value?.scrollTo({ top: 0, left: 0 })
})
</script>

<template>
  <xAppGuide v-if="!$route.meta.hideGuide && !isAppByRoute" />
  <n-scrollbar id="x-wrap" ref="scroll" x-scrollable content-class="flex flex-col" class="flex flex-col w-screen h-screen bg-fillPagePrimary">
    <Header v-if="!$route.meta.hideHeader && !isAppByRoute" />
    <div
      class="flex-1"
      :class="[{ 'min-w-[1280px]': !$route.meta?.supportMobile },
      ]"
    >
      <slot />
    </div>
    <ClientOnly>
      <Footer v-if="!$route.meta.hideFooter" />
    </ClientOnly>
  </n-scrollbar>
</template>
